<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .table-scroll-container {
    overflow: hidden;
    border-radius: 0 0 10px 10px;
    border-top: none;
    position: relative;
    height: utils.in_rem(310px);
    max-height: utils.in_rem(310px);
  }

  .table-scroll {
    overflow-y: auto;
    height: 100%;
    min-height: 0;
  }

  .field-table {
    margin: 0;
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  .col-name {
    width: 25%;
  }

  .col-displayed {
    width: 20%;
    text-align: center;
  }

  .col-mandatory {
    width: 21%;
    text-align: center;
  }

  .col-update {
    width: 34%;
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    z-index: 2;
  }
</style>

<script>
  import Spinner from "@sourcewhale/shared/svelte-design-system/components/atoms/Spinner.svelte";
  import Table from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/Table.svelte";
  import TBODY from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TBODY.svelte";
  import FieldRow from "./FieldRow.svelte";

  export let filteredFields = [];
  export let isLoading = false;
  export let type;
</script>

<div class="table-scroll-container">
  {#if isLoading}
    <div class="loading-overlay">
      <Spinner size="xl" />
    </div>
  {/if}
  <div class="table-scroll">
    <Table class="field-table">
      <colgroup>
        <col class="col-name" />
        <col class="col-displayed" />
        <col class="col-mandatory" />
        <col class="col-update" />
      </colgroup>
      <TBODY>
        {#each filteredFields as field (field.key)}
          <FieldRow {field} {type} />
        {/each}
      </TBODY>
    </Table>
  </div>
</div>
